import React, { useState } from "react";

import { queryClient } from '../../state/queryClient';
import {  useCommissions} from '../../state/reactquery';
import { axios_gestion_updatecommission , axios_gestion_createcommission} from "../../axios/axios_gestion";
 
import './EcranGestionCommissions.scss' ; 
function EcranGestionCommissions(){

    const {data : commissions}= useCommissions() ;
    const [displaynewcommission,setDisplaynewcommission] = useState(false)


    const newprice =async (e)=>{
        const ancienpprix = commissions.filter(c=>c.id===e.target.id)?.[0]?.prix ;
        const nouveauprix = e.target.textContent ;
        if(ancienpprix!==nouveauprix){
            await axios_gestion_updatecommission({id:e.target.id,prix:e.target.textContent});
            queryClient.invalidateQueries({ queryKey: ['commissions']})  ;
        } 
    }

    function verifcom(com){
        if(!['campagne', 'debut', 'origine', 'prix'].every(c=>com[c]?.trim()?.length!==0)){return false}
        if(!(/^[\d,\.]+$/.test(com.prix))){return false}
        if(!(/^(\d{2})\/(\d{2})\/(\d{4})$/.test(com.debut))){return false}
        return true;                                                                                           
    }
   

    const enregistrer =async ()=>{
        const items =document.getElementsByClassName('champnewcampagnge') ;
        
        let newcampagne={} ; [].map.call(items, item => newcampagne[item.id] = item.textContent.trim());
        if(!verifcom(newcampagne)){return }
 
        await axios_gestion_createcommission({...newcampagne, 'prix':newcampagne.prix.replace(',','.')}) ;
        queryClient.invalidateQueries({ queryKey: ['commissions']})  ;

        setDisplaynewcommission(false)
    }

    return (<div  className='divtabcommissions' ><br/> <br/>  <table>
                   <thead><tr>
                        <td>Debut de la campagne</td><td>Origine</td><td>campagne</td><td>Prix</td>
                    </tr></thead>
                            <tbody>
                                 {commissions?.map((com,index)=><tr key={index}>
                                     <td>{ new Date(com.debut).toLocaleString("fr-FR", {timeZone: "Europe/Paris"}).split(' ')[0]}</td>
                                     <td>{com.origine}</td>
                                     <td>{com.campagne}</td>
                                     <td className="tdchampprix">
                                      <div id={com.id} className='champprix'  contentEditable="true" 
                                           suppressContentEditableWarning={true}
                                           onBlur={newprice}>
                                            {com.prix} 
                                      </div>  
                                     </td>
                                    </tr>)} 
                                   { displaynewcommission && <tr>
                                             <td className="tdchampprix">
                                                <div id='debut'  className='champnewcampagnge'  contentEditable="true"  suppressContentEditableWarning={true}> 
                                                    JJ/MM/AAAA 
                                                </div>  
                                            </td>
                                            <td className="tdchampprix">
                                                <div id='origine'  className='champnewcampagnge'  contentEditable="true"  suppressContentEditableWarning={true}>  
                                                </div>  
                                            </td>
                                            <td className="tdchampprix">
                                                <div id='campagne'  className='champnewcampagnge'  contentEditable="true"  suppressContentEditableWarning={true}>  
                                                </div>  
                                            </td>
                                             <td className="tdchampprix">
                                                <div id='prix'  className='champnewcampagnge'  contentEditable="true"  suppressContentEditableWarning={true}>  
                                                </div>  
                                            </td>
                                    </tr>}
                            </tbody>
        </table>
        <br/> <br/> 
        {displaynewcommission ? <div  className='addcommissionbtn' onClick={enregistrer}>Enregistrer</div>:
            <div  className='addcommissionbtn' onClick={()=>{setDisplaynewcommission(true)}}>Ajouter une commission</div>}
        </div>)
}


export default EcranGestionCommissions